import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { showDialog } from '../../../../store/actions/prescriptionPad';
import { getPtPastVitals } from '../../../../store/selectors/prescriptionPad';

const LabVitalCardHeaderActions: React.FC = () => {
    const ptPastVitals = useSelector(getPtPastVitals);

    const dispatch = useDispatch();

    if (!ptPastVitals || Object.keys(ptPastVitals).length === 0) {
        return null;
    }

    const showLongitudinalView = () => {
        dispatch(showDialog('longitudinal-vital-view'));
    };

    return (
        <button
            onClick={showLongitudinalView}
            style={{ fontWeight: 400 }}
            className="secondary-btn px-8 py-4 body-2 space-x-10"
        >
            <span>See Historical Data</span>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 384 512"
                className="w-14 h-14 fill-actionPrimary"
            >
                <path d="M320 64H280h-9.6C263 27.5 230.7 0 192 0s-71 27.5-78.4 64H104 64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zM80 112v24c0 13.3 10.7 24 24 24h88 88c13.3 0 24-10.7 24-24V112h16c8.8 0 16 7.2 16 16V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V128c0-8.8 7.2-16 16-16H80zm88-32a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM136 272a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm40-16c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H176zm0 96c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H176zm-64 40a24 24 0 1 0 0-48 24 24 0 1 0 0 48z" />
            </svg>
        </button>
    );
};

export default LabVitalCardHeaderActions;
